/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {identifierName} from '../compile_metadata';
import {isPresent} from '../facade/lang';

import {EmitterVisitorContext} from './abstract_emitter';
import {AbstractJsEmitterVisitor} from './abstract_js_emitter';
import * as o from './output_ast';
/**
 * @param {?} sourceUrl
 * @param {?} expr
 * @param {?} declarations
 * @param {?} vars
 * @return {?}
 */
function evalExpression(
    sourceUrl: string, expr: string, declarations: string, vars: {[key: string]: any}): any {
  const /** @type {?} */ fnBody = `${declarations}\nreturn ${expr}\n//# sourceURL=${sourceUrl}`;
  const /** @type {?} */ fnArgNames: string[] = [];
  const /** @type {?} */ fnArgValues: any[] = [];
  for (const /** @type {?} */ argName in vars) {
    fnArgNames.push(argName);
    fnArgValues.push(vars[argName]);
  }
  return new Function(...fnArgNames.concat(fnBody))(...fnArgValues);
}
/**
 * @param {?} sourceUrl
 * @param {?} statements
 * @param {?} resultVar
 * @return {?}
 */
export function jitStatements(
    sourceUrl: string, statements: o.Statement[], resultVar: string): any {
  const /** @type {?} */ converter = new JitEmitterVisitor();
  const /** @type {?} */ ctx = EmitterVisitorContext.createRoot([resultVar]);
  converter.visitAllStatements(statements, ctx);
  return evalExpression(sourceUrl, resultVar, ctx.toSource(), converter.getArgs());
}

class JitEmitterVisitor extends AbstractJsEmitterVisitor {
private _evalArgNames: string[] = [];
private _evalArgValues: any[] = [];
/**
 * @return {?}
 */
getArgs(): {[key: string]: any} {
    const /** @type {?} */ result: {[key: string]: any} = {};
    for (let /** @type {?} */ i = 0; i < this._evalArgNames.length; i++) {
      result[this._evalArgNames[i]] = this._evalArgValues[i];
    }
    return result;
  }
/**
 * @param {?} ast
 * @param {?} ctx
 * @return {?}
 */
visitExternalExpr(ast: o.ExternalExpr, ctx: EmitterVisitorContext): any {
    const /** @type {?} */ value = ast.value.reference;
    let /** @type {?} */ id = this._evalArgValues.indexOf(value);
    if (id === -1) {
      id = this._evalArgValues.length;
      this._evalArgValues.push(value);
      const /** @type {?} */ name = identifierName(ast.value) || 'val';
      this._evalArgNames.push(`jit_${name}${id}`);
    }
    ctx.print(this._evalArgNames[id]);
    return null;
  }
}

function JitEmitterVisitor_tsickle_Closure_declarations() {
 /** @type {?} */
JitEmitterVisitor.prototype._evalArgNames;
 /** @type {?} */
JitEmitterVisitor.prototype._evalArgValues;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
